import React from 'react'

const UOM = () => {
  return (
    <div>UOM</div>
  )
}

export default UOM